/*
 * File: /src/router/routes/knowledgeCategories.js
 * Author: AdBase, Inc.
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const KnowledgeCategoryList = () =>
  import(
    /* webpackChunkName: "KnowledgeCategories" */ 'src/components/Dashboard/Views/KnowledgeCategories/KnowledgeCategoryList.vue'
  );
const KnowledgeCategoryEdit = () =>
  import(
    /* webpackChunkName: "KnowledgeCategories" */ 'src/components/Dashboard/Views/KnowledgeCategories/KnowledgeCategoryEdit.vue'
  );

export const knowledgeCategoryRoutes = [
  {
    path: 'knowledge-categories/list',
    name: 'Knowledge Category List',
    component: KnowledgeCategoryList,
  },
  {
    path: 'knowledge-categories/add',
    name: 'Knowledge Category Add',
    component: KnowledgeCategoryEdit,
    props: () => ({
      id: undefined,
    }),
  },
  {
    path: 'knowledge-categories/edit/:id',
    name: 'Knowledge Category Edit',
    component: KnowledgeCategoryEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
];
